"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupBringsAFriendForm = setupBringsAFriendForm;
exports.readTrialBookingFriendParticipants = readTrialBookingFriendParticipants;
var cash_dom_1 = __importDefault(require("cash-dom"));
var FRIEND_FIELD_MAPPING = {
    'friend.firstname': 'givenName',
    'friend.lastname': 'familyName',
    'friend.email': 'email',
    'friend.telephone_mobile': 'phone',
};
function setupBringsAFriendForm($container, references) {
    var friendFormRef = references === null || references === void 0 ? void 0 : references.trialbookingFriendForm;
    var friendFormParent = friendFormRef === null || friendFormRef === void 0 ? void 0 : friendFormRef.parent;
    if (friendFormParent === null || friendFormParent === void 0 ? void 0 : friendFormParent.length) {
        friendFormParent.css({
            display: 'none',
        });
    }
    var bringsAFriendCheckbox = $container.find('input[type="checkbox"][data-get="bringsAFriend"]');
    if (bringsAFriendCheckbox.length === 0) {
        return;
    }
    var updateFriendForm = function () {
        var _a;
        if (!((_a = friendFormRef === null || friendFormRef === void 0 ? void 0 : friendFormRef.domElement) === null || _a === void 0 ? void 0 : _a.length) || !(friendFormParent === null || friendFormParent === void 0 ? void 0 : friendFormParent.length)) {
            return;
        }
        friendFormRef.removeClones();
        if (isBringsAFriendEnabled(bringsAFriendCheckbox)) {
            var friendFormClone = friendFormRef.cloneDomElement();
            if (friendFormClone === null || friendFormClone === void 0 ? void 0 : friendFormClone.length) {
                indexFriendForm(friendFormClone, 0);
                friendFormParent.append(friendFormClone);
            }
            friendFormParent.css({
                display: '',
            });
        }
        else {
            friendFormParent.css({
                display: 'none',
            });
        }
    };
    bringsAFriendCheckbox.on('change', updateFriendForm);
    updateFriendForm();
}
function readTrialBookingFriendParticipants($container) {
    var friendForms = $container.find('[data-clone-id="trialbookingFriendForm"]');
    var participants = [];
    friendForms.each(function (index, element) {
        var friendForm = (0, cash_dom_1.default)(element);
        indexFriendForm(friendForm, index);
        var participant = readFriendForm(friendForm, index);
        participants.push(participant);
    });
    return participants;
}
function indexFriendForm(friendForm, index) {
    friendForm.attr('data-participant-index', String(index));
    indexFriendDataGet(friendForm, index);
    friendForm.find('[data-get]').each(function (_, element) {
        indexFriendDataGet((0, cash_dom_1.default)(element), index);
    });
}
function indexFriendDataGet(element, index) {
    var friendDataGet = element.attr('data-friend-get') || element.attr('data-get');
    var participantKey = FRIEND_FIELD_MAPPING[friendDataGet];
    if (!participantKey) {
        return;
    }
    element.attr('data-friend-get', friendDataGet);
    element.attr('data-get', "participantData.".concat(index, ".").concat(participantKey));
}
function readFriendForm(friendForm, index) {
    var givenName = readIndexedFriendField(friendForm, index, 'givenName');
    var familyName = readIndexedFriendField(friendForm, index, 'familyName');
    var email = readIndexedFriendField(friendForm, index, 'email');
    var phone = readIndexedFriendField(friendForm, index, 'phone');
    return {
        givenName: givenName,
        familyName: familyName,
        email: email,
        phone: phone || undefined,
    };
}
function readIndexedFriendField(friendForm, index, participantKey) {
    var dataGet = "participantData.".concat(index, ".").concat(participantKey);
    var field = friendForm.attr('data-get') === dataGet ? friendForm : friendForm.find("[data-get=\"".concat(dataGet, "\"]"));
    return readFriendFieldValue(field);
}
function readFriendFieldValue(field) {
    if (field.length === 0) {
        return '';
    }
    var input = field.filter('input, select, textarea').length ? field : field.find('input, select, textarea').first();
    if (input.length) {
        return String(input.val() || '').trim();
    }
    return String(field.text() || '').trim();
}
function isBringsAFriendEnabled(bringsAFriendCheckbox) {
    if (!(bringsAFriendCheckbox === null || bringsAFriendCheckbox === void 0 ? void 0 : bringsAFriendCheckbox.length)) {
        return false;
    }
    return bringsAFriendCheckbox.get(0).checked;
}
